<div class="row justify-content-center allergy-card">
  <!-- <div class="col-6 col-sm-5 col-md-3" *ngIf="objPatientAllergy.length == 0">
          <div class="bg-info h-100 card mb-3 p-3 text-center text-white" data-toggle="modal"
          (click)="onModalAllergy(operationAdd)">
          <span class="icon mb-3"><img height="25" src="../../../assets/images/Icons/plus.svg"></span>
          <h6 class="font-weight-normal mb-0">Add Allergy</h6>
      </div>
  </div> -->

  <div class="col-6 col-sm-5 col-md-3" *ngIf="objPatientAllergy.length == 0">
    <div class="bg-info card h-100 mb-3 p-3 text-center text-white" (click)="onModalAllergy(operationAdd)">
      <span class="bg-white icon mb-3"><img height="25" src="../../../assets/images/Icons/plus.svg"></span>
      <h6 class="font-weight-normal mb-0">{{'allergy.allergy_add_allergy'|translate}}</h6>
    </div>
  </div>

  <div class="col-6 col-sm-5 col-md-3" *ngIf="objPatientAllergy.length == 0">
    <div class="card mb-3 h-100 p-3 text-center text-info" (click)="setNoKnownAlrgMedFam('allergy')">
      <span class="icon mb-3"><img height="23" src="../../../assets/images/Icons/cross.svg"></span>
      <h6 class="font-weight-normal mb-0">{{'allergy.allergy_no_known_allergy'|translate}}</h6>
    </div>
  </div>

  <!--<div class="col-12" *ngIf="objPatientAllergy.length != 0">
    <button class="btn btn-primary btncare" style="float: right;" type="button" (click)="onModalAllergy(operationAdd)">{{'button.add_allergy'|translate}}</button>
  </div>-->


  <!-- <div class="col-12 mt-4">
  <ng-container *ngIf="!isLoadingPE">
      <ng-container *ngIf="objPatientAllergy.length > 0 else notFoundPA">
          <ng-container *ngFor="let allergy of objPatientAllergy;">
              <table class="table table-bordered">
                  <tr [ngStyle]="{'display' : intakeFieldsSetting.isAllergytype ? '' : 'none'}">
                      <td width="150">Allergy Type</td>
                      <td>{{allergy.allergyType || 'N/A'}}</td>
                  </tr>
                  <tr [ngStyle]="{'display' : intakeFieldsSetting.isSearchAllergy ? '' : 'none'}">
                      <td width="150">Allergy</td>
                      <td>{{allergy.allergyDescription || 'N/A'}}</td>
                  </tr>
                  <tr [ngStyle]="{'display' : intakeFieldsSetting.isSeverity ? '' : 'none'}">
                      <td width="150">Severity</td>
                      <td>{{allergy.allergySeverity || 'N/A'}}</td>
                  </tr>
                  <tr [ngStyle]="{'display' : intakeFieldsSetting.isReaction ? '' : 'none'}">
                      <td width="150">Reaction</td>
                      <td>{{allergy.allergyReactionDescription || 'N/A'}}</td>
                  </tr>
                  <tr>
                      <td width="150">Action</td>
                      <td *ngIf="allergy.recounciledData=='True'">
                          <div class="ctabtns">
                              <a (click)="onModalAllergy(operationEdit, allergy)" data-toggle="modal"
                              class="mr-3"><i title="Edit" class="fas fa-edit text-dark"></i></a>
                              <a (click)="onDeleteAllergy(allergy)" data-toggle="modal"><i title="Delete"
                                  class="far fa-trash-alt text-danger"></i></a>
                              </div>
                          </td>
                          <td *ngIf="allergy.recounciledData=='False'">
                              <div class="ctabtns">
                                  <a (click)="onAllergyProvider('edit')" data-toggle="modal"
                                  class="mr-3"><i title="Edit" class="fas fa-edit text-dark"></i></a>
                                  <a (click)="onAllergyProvider('delete')" data-toggle="modal"><i title="Delete"
                                      class="far fa-trash-alt text-danger"></i></a>
                                  </div>
                              </td>
                          </tr>

                      </table>
                  </ng-container>
              </ng-container>
              <ng-template #notFoundPA>

                  <div class="col-12 mt-4">
                      <div class="card border">
                          <div class="card-body text-center">
                              <p class="mb-0">No Allergies history.</p>
                          </div>
                      </div>
                  </div>
              </ng-template>
          </ng-container>
      </div> -->
</div>



<ng-container *ngIf="!isLoadingPE">
  <ng-container *ngIf="objPatientAllergy.length > 0 else notFoundPA">
    <div class="container flex-grow-1 overflow-auto">
      <div class="specialist-list ">
        <div class="form-row">
          <div class="col-12 mb-4 mt-2" *ngIf="objPatientAllergy.length != 0">
            <button class="btn btn-primary btncare" style="float: right;" type="button" (click)="onModalAllergy(operationAdd)">{{'button.add_allergy'|translate}}</button>
          </div>
          <div class="col-lg-6" *ngFor="let allergy of objPatientAllergy;">
            <div class="card mb-4 pb-3">
              <div class="card-body p-0">
                <div class="align-items-center d-flex justify-content-between mb-2" style="align-items: flex-start !important;">
                  <!--<h6 class="font-weight-bold mb-0" *ngIf="(allergy.allergyType=='Drug')">
            {{'allergy.allergy_add_modal_drug'|translate}}
          </h6>
          <h6 class="font-weight-bold mb-0" *ngIf="(allergy.allergyType=='Food')">
            {{'allergy.allergy_add_modal_food'|translate}}
          </h6>
          <h6 class="font-weight-bold mb-0" *ngIf="(allergy.allergyType=='Environment')">
            {{'allergy.allergy_add_modal_environment'|translate}}
          </h6>-->
                  <h6 class="font-weight-bold mb-0" [ngStyle]="{'display' : intakeFieldsSetting.isSearchAllergy ? '' : 'none'}">
                    <span>{{(allergy.allergyDescription |titlecase)|| 'N/A'}}</span>
                  </h6>


                  <div class="ctabtns " *ngIf="allergy.recounciledData=='True'">
                    <!--<a (click)="onModalAllergy(operationEdit, allergy)" class="mr-3">
              <i title="{{'link.edit'|translate}}"
                 class="fas fa-edit text-dark"></i>
            </a>-->
                    <a href="javascript:void(0)" (click)="onDeleteAllergy(allergy)" class="text-dark">
                      {{'link.delete'|translate}}
                      <!--<i title="{{'link.delete'|translate}}"
                 class="far fa-trash-alt text-danger"></i>-->

                    </a>
                  </div>

                  <div class="ctabtns" *ngIf="allergy.recounciledData=='False'">
                    <!--<a (click)="onAllergyProvider('edit')" class="mr-3">
              <i title="{{'link.edit'|translate}}"
                 class="fas fa-edit text-dark"></i>
            </a>-->
                    <a href="javascript:void(0)" (click)="onAllergyProvider('delete')">
                      {{'link.delete'|translate}}
                      <!--<i title="{{'link.delete'|translate}}"
                 class="far fa-trash-alt text-danger"></i>-->
                    </a>
                  </div>
                </div>
                <!--<div class="mb-2"
            [ngStyle]="{'display' : intakeFieldsSetting.isSearchAllergy ? '' : 'none'}">
          <span class="text-muted font-weight-bold mr-1">{{'allergy.allergy_name'|translate}}</span>
            <span>{{allergy.allergyDescription || 'N/A'}}</span>
        </div>-->
                <div class="mb-2"
                     [ngStyle]="{'display' : intakeFieldsSetting.isSeverity ? '' : 'none'}">
                  <span >{{'allergy.allergy_severity'|translate}} </span>
                  <span class="text-muted font-weight-bold mr-1">{{(allergy.allergySeverity |titlecase)|| 'N/A'}}</span>
                </div>
                <div [ngStyle]="{'display' : intakeFieldsSetting.isReaction ? '' : 'none'}">
                  <span >{{'allergy.allergy_reaction'|translate}} </span>
                  <span class="text-muted font-weight-bold mr-1">{{ (allergy.allergyReactionDescription | titlecase) || 'N/A' }}</span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #notFoundPA>

    <div class="col-12 mt-4 text-center px-0">
      <p class="mb-0 text-danger">{{'allergy.allergy_no_allergies_history'|translate}}</p>
    </div>
  </ng-template>
</ng-container>



<!-- add  -->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse modal-full-height" id="Allergy-Modal">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'allergy.allergy_add_allergy'|translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <div class="insurance-tab">
          <!--<ul class="bg-info justify-content-between mb-3 nav nav-pills p-2 rounded text-center"
      [ngStyle]="{'display': intakeFieldsSetting.isAllergytype ? '' : 'none' }" id="pills-tab"
      role="tablist">
      <li class="flex-fill nav-item" role="presentation">
        <a class="nav-link rounded"
           [ngClass]="selected_objPatientAllergy.allergyTypeId == '1'? 'active' : ''"
           aria-expanded="true" id="drugType" role="tab" data-toggle="tab"
           (click)="onSetAllergyType('MEDICINE', '1')">{{'allergy.allergy_add_modal_drug'|translate}}</a>

      </li>
      <li class="flex-fill nav-item" role="presentation">
        <a class="nav-link rounded"
           [ngClass]="selected_objPatientAllergy.allergyTypeId == '2'? 'active' : ''"
           aria-expanded="false" id="drugType" role="tab" data-toggle="tab"
           (click)="onSetAllergyType('Food', '2')">{{'allergy.allergy_add_modal_food'|translate}}</a>


      </li>
      <li class="flex-fill nav-item" role="presentation">
        <a class="nav-link rounded"
           [ngClass]="selected_objPatientAllergy.allergyTypeId == '3'? 'active' : ''"
           aria-expanded="false" id="drugType" role="tab" data-toggle="tab"
           (click)="onSetAllergyType('Environment', '3')">{{'allergy.allergy_add_modal_environment'|translate}}</a>
      </li>
  </ul>-->
          <style>
            .cancel-icon {
              cursor: pointer;
              position: absolute;
              right: 0px;
              top: 10px;
              font-size: 18px;
              color: #52b0ba !important;
              background: white;
              padding-left: 10px;
              padding-right: 10px;
              float: right;
            }

              .cancel-icon:hover {
                color: #52b0ba !important; /* Change color on hover */
              }

            @media (max-width: 768px) {
              .cancel-icon {
                color: #52b0ba !important;
              }
            }
          </style>

          <div class="form-row">
            <div class="col-md-12" [ngStyle]="{'display' : intakeFieldsSetting.isSearchAllergy ? '' : 'none'}">
              <div class="input-group mb-3 w-100 border-bottom">
                <label class="form-label fw-bold">{{'allergy.allergy_add_modal_allergy'|translate}}<span class="text-danger">*</span></label>
                <div class="dropdown w-100" ngbDropdown
                     [ngClass]="(allergyDrop.isOpen() && selected_objPatientAllergy.allergyDescription.length > 0) ? '' : 'input-icon search'"
                     #allergyDrop="ngbDropdown">

                  <input placeholder="{{'allergy.allergy_search_placeholder'|translate}}" class="form-control text-left border-0 ltr-component"
                         ngbDropdownAnchor (focus)="allergyDrop.open()" id="allergysearchdropdown"
                         type="text" aria-haspopup="true" aria-expanded="false"
                         [(ngModel)]="selected_objPatientAllergy.allergyDescription"
                         (keyup)="GetSolarApiAllergies($event)">

                  <!-- Cancel Icon for Allergy Input -->
                  <span *ngIf="allergyDrop.isOpen() && selected_objPatientAllergy.allergyDescription.length > 0"
                        class="cancel-icon"
                        style="color: #52b0ba !important"
                        (click)="clearAllergyInput(); allergyDrop.close()">
                    <i class="fas fa-times" style="color: #52b0ba;"></i>
                  </span>

                  <div ngbDropdownMenu class="custom-menu" aria-labelledby="allergysearchdropdown"
                       [ngClass]="{'d-none': dNoneallergy}">
                    <button ngbDropdownItem *ngIf="isLoading">
                      <span>{{'allergy.allergy_add_modal_loading'|translate}}</span>
                    </button>
                    <button ngbDropdownItem
                            *ngIf="filteredAllergyies?.length === 0 && selected_objPatientAllergy.allergyDescription.length > 0 && !isLoading">
                      {{'allergy.allergy_add_modal_no_record_found'|translate}}
                    </button>
                    <button ngbDropdownItem *ngFor="let items of filteredAllergyies"
                            (click)="SetAllergies(items.DESCRIPTION)">
                      {{ items.DESCRIPTION }}
                    </button>
                  </div>
                </div>
              </div>
              <p *ngIf="allergyError" class="err">{{allergyError}}</p>
            </div>



            <div class="col-md-12" [ngStyle]="{'display': intakeFieldsSetting.isSeverity ? '' : 'none' }">
              <div class="form-group has-search form-select mb-4 border-bottom">
                <label class="form-label fw-bold">{{'allergy.allergy_add_modal_severity'|translate}} </label>
                <select name="ctl00$main$SeverityDropDown" id="main_SeverityDropDown"
                        class="form-control border-0" [(ngModel)]="selected_objPatientAllergy.allergySeverityId"
                        (change)="onChangeSeverity()">
                  <option value="">{{'allergy.allergy_add_modal_select_severity_level'|translate}}</option>
                  <option *ngFor="let severity of severtydropdownList;" [value]="severity.value">
                    {{severity.text}}
                  </option>
                </select>

              </div>
            </div>
            <div class="col-md-12" [ngStyle]="{'display': intakeFieldsSetting.isReaction ? '' : 'none' }">

              <div class="form-group mb-4 border-bottom">
                <label class="form-label fw-bold">{{'allergy.allergy_add_modal_reaction'|translate}}</label>
                <div class="position-relative">
                  <ng-multiselect-dropdown placeholder="{{'allergy.allergy_add_modal_search_reaction'|translate}}"
                                           id="reactionMultiSelect"
                                           class="form-group has-search form-select border-0"
                                           [(ngModel)]="selectedReactionsDropDownList" [data]="reactiondropdownList"
                                           [settings]="reactiondropdownSettings" (click)="onChangeReaction()">
                  </ng-multiselect-dropdown>
                </div>

              </div>
            </div>


            <div class="container">
              <div class="row justify-content-between">
                <div class="col-12">
                  <button class="btn btn-primary btncare w-100" type="button" (click)="onlysaveAllergy()">{{'button.save'|translate}}</button>
                  <div class="devider mb-4">
                    <span>{{'careteam.or'|translate}}</span>
                  </div>
                  <button class="btn btn-primary btncare w-100" type="button" (click)="AddanotherAllergy()">{{'button.Save_add_more'|translate}}</button>
                </div>
              </div>
            </div>






            <!--<div class="container">
      <div class="row justify-content-between">
        <div class="col-lg-6 col-md-6 col-12 mb-2 mt-3">
          <button class="btn btn-primary btncare w-100" type="button" (click)="onlysaveAllergy()">{{'button.save'|translate}}</button>
        </div>
        <div class="col-lg-6 col-md-6 col-12 mb-2 mt-3">
          <button class="btn btn-primary btncare w-100" type="button" (click)="AddanotherAllergy()">{{'button.Save_add_more'|translate}}</button>
        </div>
      </div>
    </div>-->
            <!--<div class="col-6"
        [ngStyle]="{'display': intakeFieldsSetting.isObservationDate ? '' : 'none' }">
        <div class="form-group form-floating">
            <input type="date" class="form-control" max="{{curDate | date:'yyyy-MM-dd'}}"
                [(ngModel)]="selected_objPatientAllergy.onsetDate" name="onsetDate"
                (change)="onAllergyDateChange();onChangeDate($event)" />
            <label>{{'allergy.allergy_add_modal_observation_date'|translate}}</label>
            <p *ngIf="startDateError && !isDateError" class="err">{{startDateError}}</p>
            <p *ngIf="isDateError" class="err">{{'allergy.allergy_add_modal_observation_date_should_be_prior_to_current_date'|translate}}</p>
        </div>
    </div>
    <div class="col-6" [ngStyle]="{'display': intakeFieldsSetting.isEndDate ? '' : 'none' }">
        <div class="form-group form-floating">
            <input type="date" class="form-control" max="{{curDate | date:'yyyy-MM-dd'}}"
                [(ngModel)]="selected_objPatientAllergy.resolvedDate" name="resolvedDate"
                (change)="onAllergyDateChange()" />
            <label>{{'allergy.allergy_add_modal_end_date'|translate}}</label>
            <p *ngIf="endDateError" class="err">{{endDateError}}</p>
        </div>
    </div>
    <div class="col-md-12" [ngStyle]="{'display': intakeFieldsSetting.isComments ? '' : 'none' }">
        <div class="form-group form-floating mb-0">
            <textarea placeholder="{{'allergy.allergy_add_modal_comments'|translate}}" class="form-control" id="Comment"
                (input)="CheckLength($any($event.target).value);" maxlength="200" rows="2"
                tabindex="16" style="resize: none" [(ngModel)]="selected_objPatientAllergy.comments"
                name="comments"></textarea>
            <label>{{'allergy.allergy_add_modal_comments'|translate}}</label>
            <span id="maxChar" class="pull-right" style="font-size: 10.0pt;">
              {{ wordCounter == 0 ? ('allergy.max' | translate) : (200 - wordCounter) + "/" }} 200

            </span>
        </div>
    </div>-->
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary " data-dismiss="modal">{{'button.close'|translate}}</button>
        <!--<button type="button" (click)="isFromSaveMore=false ;OnAllergySubmit()" class="btn btn-primary ">{{'button.save'|translate}}</button>-->
      </div>
    </div>
  </div>
</div>


<!-- <div class="modal fade in modal-alert bd-example-modal-sm" id="delete-allergy" tabindex="-1" role="dialog"
    data-backdrop="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body text-center">
                <i class="fa  fa-5x fa-exclamation-circle animate-blink text-warning"></i>
                <h4 class="mt-2">Delete</h4>
                <p>Are you sure you want to delete allergy?</p>
                <button class="btn btn-danger mr-3" (click)="onConfirmDeleteAllergy()">Delete</button>
                <button class="btn btn-primary" data-dismiss="modal" id="closeDeleteAllergyModel">Cancel</button>
            </div>
        </div>
    </div>
</div> -->


<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="delete-allergy">
  <!-- <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Breeze Check-in</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
              <p class="mb-0">Are you sure you want to delete allergy?</p>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary " data-dismiss="modal"
              id="closeDeleteAllergyModel">Cancel</button>
              <button type="button" id="closeDeleteFamilyHistory" (click)="onConfirmDeleteAllergy()"
              class="btn btn-primary ">Delete</button>
          </div>
      </div>
  </div> -->

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body  p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong>{{'allergy.allergy_delete_allergy_are_you_sure_you_want_to_delete_allergy'|translate}}</strong></h5>
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                id="closeDeleteAllergyModel">
          {{'button.cancel'|translate}}
        </button>
        <button type="button" id="closeDeleteFamilyHistory" (click)="onConfirmDeleteAllergy()"
                class="btn btn-primary rbtn">
          {{'button.delete'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>


<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="successallergynoknown">
  <!-- <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Breeze Check-in</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
              <p class="text-center">
                  <strong class="text-suceess">Success!</strong>
              </p>
              <p class="mb-0">No {{noKnownDate}} is set.</p>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary " data-dismiss="modal" id="closeDeleteAllergyModel">Cancel</button>
              <button type="button" id="closeDeleteFamilyHistory" class="btn btn-primary ">OK</button>
          </div>
      </div>
  </div> -->


  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong>{{'allergy.allergy_successallergynoknown_success'|translate}}</strong></h5>
        <p class="mb-3">{{'allergy.allergy_successallergynoknown_no'|translate}} {{noKnownDate}} {{'allergy.allergy_successallergynoknown_is_set'|translate}}</p>
        <button type="button" id="closeDeleteFamilyHistory" class="btn btn-primary ">{{'button.ok'|translate}}</button>
      </div>
    </div>
  </div>

</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="addMore-allergy">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body  p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong>Do you want to add another allergy?</strong></h5>
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                id="closeAddmoreAllergyModel" (click)="AddanotherAllergy()">
          {{'button.yes'|translate}}
        </button>
        <button type="button" id="closeDeleteFamilyHistory"
                class="btn btn-primary " (click)="CloseAllergyModal()">
          {{'button.no'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

